import { ModelBase, ModelState } from '../../core/model/model-base';
import { getMonthName } from '../../core/helper/month';
import { Money } from '../../core/model/money';
import { Currencies } from '../../core/pipe/currency.pipe';

export class RentalObjectImprovement extends ModelBase {
  constructor(currencyCode?: string) {
    super();
    this.performYear = new Date().getFullYear();
    this.performMonth = new Date().getMonth();
    this.currencyCode = currencyCode;
    this.cost = new Money(this.currencyCode, 0);
  }

  currencyCode: string;
  performYear: number;
  performMonth: number;
  stopYear: number;
  interval: number;
  description: string;
  cost: Money;

  valueRaisingAction: boolean;

  state: ModelState;

  get performMonthCaption(): string {
    return getMonthName(this.performMonth);
  }

  toString() {
    return `${this.description}`;
  }

  toJSON() {
    return {
      id: this.id,
      currencyCode: this.currencyCode,
      cost: this.cost,
      description: this.description,
      interval: this.interval,
      stopYear: this.stopYear,
      performMonth: this.performMonth,
      performYear: this.performYear,
      valueRaisingAction: this.valueRaisingAction,
    };
  }
}
